  (function () {
    if (window.__hlShopTracked) return;
    window.__hlShopTracked = true;

    /* The Liquid this file used to interpolate now arrives as JSON in the page.
       Missing or malformed leaves DATA empty and every branch below falls to its
       "not this template" side, which is silence rather than a throw. */
    var DATA = {};
    try { DATA = JSON.parse(document.getElementById('hl-shop-tracking-data').textContent); } catch (e) {}

    function ga() {
      // gtag is defined in theme.liquid above this snippet. Guarded anyway so a
      // future reorder degrades to silence rather than a console full of errors.
      // The try/catch is not defensive programming for its own sake: this file
      // wraps window.fetch below, so a throw from here could land inside the
      // cart's own promise chain and break adding to cart. Analytics is never
      // allowed to be the reason a shop stops selling.
      try {
        if (typeof window.gtag === 'function') window.gtag.apply(null, arguments);
      } catch (e) {}
    }
    function group() {
      return (window.__hlGaParams && window.__hlGaParams.content_group) || 'other';
    }
    function handleOf(href) {
      var m = /\/products\/([^/?#]+)/.exec(href || '');
      return m ? m[1] : null;
    }
    // once('faq_open:3') — every threshold-style event below fires at most once
    // per page load, and this is the single place that is enforced.
    var fired = {};
    function once(key) {
      if (fired[key]) return false;
      fired[key] = true;
      return true;
    }

    /* ---------- can a scroll on THIS element mean anything to us? ----------
       Asked once per element and remembered, because the answer is a layout
       read and it barely changes.

       Both depth listeners below are capture-phase on the document, which is
       the only way to see this theme's inner scroller without hard-coding its
       class — and the price of that is hearing every OTHER scroller too. The
       expensive one is the product gallery: a horizontal strip of photographs
       that a shopper flicks, which cannot change how far down a page they have
       read and cannot move the description column, but which fires scroll
       faster than the browser paints.

       Measured before this guard, three flicks of the gallery on
       globe-pull-chain-wall-sconce at 433px, 4x CPU: 240 layout-forcing reads
       from this file alone — 96 scrollHeight and 48 clientHeight in
       scroll_depth, 48 getBoundingClientRect and 48 innerHeight in
       pdp_read_depth — every one of them answering a question about a gesture
       that could not have changed the answer. It is the textbook thrash shape,
       and it runs on every scroll in the store, not only here.

       200px of scroll range is the same threshold scroll_depth already applied
       further down; this just applies it before the reads instead of after
       them. Deliberately NOT window.hlMovesThePage, which hl-sticky-cart
       defines for the same purpose with a 400px threshold: sharing the name
       would silently move one file's cutoff to the other's.

       The cache is cleared on resize and on load, the two moments a box that
       could not scroll becomes one that can. */
    var depthKind = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
    function canOwnDepth(el) {
      if (!el || el.nodeType !== 1) return true;      // document / window: always ask
      if (!depthKind) return true;                    // no WeakMap: behave as before
      var known = depthKind.get(el);
      if (known !== undefined) return known;
      var answer = (el.scrollHeight - (el.clientHeight || 0)) >= 200;
      depthKind.set(el, answer);
      return answer;
    }
    function forgetDepthKinds() { if (typeof WeakMap !== 'undefined') depthKind = new WeakMap(); }
    window.addEventListener('resize', forgetDepthKinds, { passive: true });
    window.addEventListener('load', forgetDepthKinds, { once: true, passive: true });

    /* What is in the cart right now, mirrored out of the reconciler below so
       the drawer and the exit handler can read it.

       Before this, drawer_open carried a drawer name and nothing else, so an
       abandoned cart drawer was indistinguishable from any other -- an $857
       wall panel left on the last screen this store controls looked exactly
       like a $50 board. Value and count are the two fields that make the
       abandonment worth chasing or not. */
    var CART = { count: 0, value: 0 };
    var cartDrawerSeen = false;
    // Prices render as "$49.99" / "1.234,00 €" depending on locale. Strip
    // everything that is not a digit or a separator, then decide which
    // separator was the decimal one by which comes last.
    function money(text) {
      if (!text) return null;
      var s = String(text).replace(/[^\d.,]/g, '');
      if (!s) return null;
      var lastComma = s.lastIndexOf(','), lastDot = s.lastIndexOf('.');
      if (lastComma > lastDot) s = s.replace(/\./g, '').replace(',', '.');
      else s = s.replace(/,/g, '');
      var n = parseFloat(s);
      return isFinite(n) ? n : null;
    }
    function productId() {
      var el = document.querySelector('product-price[data-product-id], product-inventory[data-product-id], [data-product-id]');
      return el ? el.getAttribute('data-product-id') : null;
    }
    function text(el, max) {
      return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim().slice(0, max || 100);
    }

    function start() {
      /* ---------- select_item: the click on a product card ----------
         Delegated from document and resolved with closest(), so it survives the
         theme's card markup changing and works for cards rendered later by
         infinite scroll or a quick-add modal. data-product-id is on the card
         wrapper; the handle comes from the link, which is the value that joins
         to D1, the manager and the blog tracking. */
      document.addEventListener('click', function (e) {
        var card = cardOf(e.target);
        if (!card) return;
        var link = card.querySelector('a[href*="/products/"]');
        var handle = handleOf(link && link.getAttribute('href'));
        if (!handle) return;

        /* Position within its own grid, 1-based, counted against the SAME list
           element product_list_view measured — not against card.parentElement,
           which on this theme is a wrapper holding a single card, so the old
           count returned 1 for every card in the grid. A position that is
           always 1 is worse than no position: it reads as "the first card gets
           every click". */
        var list = listContainer(card) || card.parentElement;
        var siblings = cardsIn(list);
        var index = 0;
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] === card || siblings[i].contains(card)) { index = i + 1; break; }
        }

        /* Named by listName(), the SAME function product_list_view uses. It
           was a copy of that logic living here; two copies of "what is this
           grid called" is how an impression and a click end up in different
           buckets and a click-through rate silently becomes uncomputable. */
        ga('event', 'select_item', {
          item_list_name: listName(card),
          product_handle: handle,
          product_id: card.getAttribute('data-product-id'),
          product_title: (link.getAttribute('aria-label') || link.textContent || '').trim().slice(0, 100),
          position: index,
          content_group: group()
        });
      }, true);

      /* ---------- scroll_depth ----------
         Capture phase on document catches a scroll on ANY element, which is the
         only way to see this theme's inner scroller without hard-coding its
         class. Thresholds fire once per page. 90 is kept alongside 100 because
         a sticky element means the last pixels are often unreachable, and a
         page that only ever reaches 90 is a different story from one nobody
         finishes. */
      /* Three changes, none of which move the numbers this reports:

         it measures ONCE PER FRAME, not once per scroll event. A phone fires
         scroll far more often than it paints, and every one of those events was
         reading scrollHeight twice and clientHeight once — so the browser had
         to flush layout each time to answer a question whose answer can only
         change between frames anyway.

         it asks canOwnDepth FIRST, so a flick of the photo gallery is dropped
         before any layout is touched.

         it UNBINDS once the last threshold has fired. 100% is reported at most
         once per page, and after that this listener had nothing left to learn
         and was still reading layout on every scroll for the rest of the
         session. */
      var marks = [25, 50, 75, 90, 100];
      var depthFired = 0, depthPending = null, depthQueued = false;

      function measureDepth() {
        depthQueued = false;
        var el = depthPending;
        depthPending = null;
        if (!el || !el.scrollHeight) return;
        var view = el.clientHeight || window.innerHeight;
        var max = el.scrollHeight - view;
        if (max < 200) return;              // not a scrollable surface
        /* scroll_start — the reader moved the page at all, 2026-10-15. The marks
           below are shares of the WHOLE document, footer and related posts
           included: 25% is 3,400px down a 13,600px article. A reader who scrolled
           to the product embed near the top and stopped there sent nothing (owner's
           replay of 14/10), so "scrolled" could not separate people from the bots
           that sit on a page without moving it. Two-fifths of a screen is past any
           accidental nudge. */
        if (el.scrollTop >= view * 0.4 && once('scroll:start')) {
          ga('event', 'scroll_start', { content_group: group() });
        }
        var pct = Math.round((el.scrollTop / max) * 100);
        for (var i = 0; i < marks.length; i++) {
          if (pct >= marks[i] && once('scroll:' + marks[i])) {
            depthFired++;
            ga('event', 'scroll_depth', {
              percent_scrolled: marks[i],
              content_group: group()
            });
          }
        }
        if (depthFired >= marks.length) document.removeEventListener('scroll', onDepthScroll, true);
      }

      function onDepthScroll(e) {
        var el = e.target === document ? document.documentElement : e.target;
        if (!canOwnDepth(el)) return;
        depthPending = el;
        if (depthQueued) return;
        depthQueued = true;
        requestAnimationFrame(measureDepth);
      }
      document.addEventListener('scroll', onDepthScroll, { capture: true, passive: true });

      /* ---------- image_zoom_open / _change / _close ----------
         Reported by zoom-dialog.js itself (`hl:zoom`), which is the only place
         that knows a swipe from a thumbnail tap and how the dialog was left.
         Every surface that has the theme's zoom — product page, the product
         embedded in a blog post, quick view — goes through the same dialog, so
         one listener here covers them all; `surface` says which. Replaces the
         product page's product_image_zoom, which polled for a dialog after a tap,
         only existed on the product template, and never saw a change or a close. */
      document.addEventListener('hl:zoom', function (e) {
        var d = e.detail || {};
        var t = e.target;
        var embed = t.closest && t.closest('[data-hl-embed]');
        var surface = embed ? 'blog_embed'
          : t.closest && t.closest('dialog:not(.dialog-zoomed-gallery__dialog), quick-add-component, .quick-add-modal') ? 'quick_view'
          : group() === 'product' ? 'pdp' : group();
        var m = location.pathname.match(/\/products\/([^/?#]+)/);
        var props = {
          surface: surface,
          product_handle: embed ? embed.getAttribute('data-hl-embed') : (m ? m[1] : undefined),
          image_index: (d.index | 0) + 1,
          content_group: group()
        };
        if (d.action === 'open') props.image_count = d.count;
        if (d.action === 'change' || d.action === 'close') props.method = d.method;
        if (d.action === 'close') { props.images_viewed = d.viewed; props.duration_ms = d.ms; }
        ga('event', 'image_zoom_' + d.action, props);
      });

      /* ---------- engaged_10s / 30s / 60s ----------
         Cumulative time the page was actually VISIBLE, not wall-clock since
         load: a tab left open in the background for an hour is not engagement,
         and counting it that way is how a bounce turns into a "high interest"
         session. One interval at 1Hz, cancelled once 60s is reached, so an
         idle page stops costing anything. */
      var engagedMs = 0, lastTick = Date.now();
      var steps = [10, 30, 60];
      var engagedTimer = setInterval(function () {
        var now = Date.now();
        if (document.visibilityState === 'visible') engagedMs += now - lastTick;
        lastTick = now;
        for (var i = 0; i < steps.length; i++) {
          if (engagedMs >= steps[i] * 1000 && once('engaged:' + steps[i])) {
            ga('event', 'engaged_' + steps[i] + 's', { content_group: group() });
          }
        }
        if (engagedMs >= steps[steps.length - 1] * 1000) clearInterval(engagedTimer);
      }, 1000);
      // Without this, time spent hidden between two ticks is billed as visible.
      document.addEventListener('visibilitychange', function () { lastTick = Date.now(); });

      /* ---------- trust: shipping / returns / reviews ----------
         Two shapes on this site: the .hl-help link row (which navigates away —
         GA4 transports over sendBeacon by default, so the hit survives the
         unload) and any accordion whose visible label mentions the topic. The
         label test is intentionally loose: these blocks get rewritten often and
         a selector pinned to today's class names would quietly stop reporting. */
      var TRUST = [
        { ev: 'shipping_info_open', href: /shipping|delivery/i, label: /shipping|delivery|dispatch/i },
        { ev: 'returns_info_open',  href: /return|refund/i,     label: /return|refund|exchange/i }
      ];
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var link = t.closest('a[href]');
        var head = t.closest('summary, .hl-faqx-q, [role="button"]');
        for (var i = 0; i < TRUST.length; i++) {
          var rule = TRUST[i];
          var hit = (link && rule.href.test(link.getAttribute('href') || '')) ||
                    (head && rule.label.test(text(head, 80)));
          // The FAQ accordion has its own event; only count it here when the
          // question is genuinely about shipping or returns.
          if (!hit || !once(rule.ev)) continue;
          ga('event', rule.ev, {
            link_text: text(link || head, 100),
            product_handle: handleOf(location.pathname) || undefined,
            content_group: group()
          });
        }
      }, true);

      /* reviews_view — nothing on the storefront matches these selectors today.
         Kept because the alternative is discovering, the week reviews launch,
         that the first month of data was never collected. */
      var reviewBlock = document.querySelector(
        '.hl-reviews, [data-hl-reviews], #shopify-product-reviews, .product-reviews, .spr-reviews, [class*="judgeme"]'
      );
      if (reviewBlock && 'IntersectionObserver' in window) {
        var revObs = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting && once('reviews_view')) {
              ga('event', 'reviews_view', {
                product_handle: handleOf(location.pathname) || undefined,
                content_group: group()
              });
              revObs.disconnect();
            }
          }
        }, { threshold: 0.4 });
        revObs.observe(reviewBlock);
      }

      /* ---------- email capture ----------
         Every newsletter form on the site posts to /contact with an email
         field — ours and the theme's, footer and popup alike (see the
         hl-newsletter-inline script, which retargets them all at a hidden
         iframe). Matching on the action rather than on a class means a new
         popup app is measured the day it is installed.

         placement matters more than the count: a footer form and a popup with
         the same submit count are not the same product decision. */
      var forms = document.querySelectorAll('form[action*="/contact"]');
      Array.prototype.forEach.call(forms, function (form, n) {
        var email = form.querySelector('input[type="email"]');
        if (!email) return;
        var placement = form.closest('dialog, [role="dialog"], .modal, .popup') ? 'popup'
                      : form.closest('footer, .footer') ? 'footer'
                      : 'inline';
        var key = placement + ':' + n;

        if ('IntersectionObserver' in window) {
          var obs = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting && once('ecv:' + key)) {
                ga('event', 'email_capture_view', { placement: placement, content_group: group() });
                obs.disconnect();
              }
            }
          }, { threshold: 0.5 });
          obs.observe(form);
        }

        // start = the field was touched. focus rather than input, because
        // giving up before typing anything is still an intent worth counting.
        //
        // data-np-autofocus, 2026-09-22: the newsletter popup's step 2 focuses
        // this field itself the instant the shopper accepts the offer, so without
        // this guard every acceptance would also report a "touch" the shopper
        // never made -- and the event would quietly become a duplicate of
        // popup_accept rather than the independent signal it is meant to be.
        // The popup sets the attribute immediately before calling focus() and
        // removes it on the next task.
        email.addEventListener('focus', function () {
          if (email.hasAttribute('data-np-autofocus')) return;
          if (once('ecs:' + key)) {
            ga('event', 'email_capture_start', { placement: placement, content_group: group() });
          }
        });

        // Mirrors the site's own submit handler: an invalid address is a
        // browser validation bounce, not a signup.
        form.addEventListener('submit', function () {
          if (!email.checkValidity()) return;
          if (once('ecx:' + key)) {
            ga('event', 'email_capture_success', { placement: placement, content_group: group() });
          }
        });
      });

      /* ---------- collection: filters and sort ----------
         Horizon names every facet input filter.<something>, so one delegated
         listener covers checkboxes, the price range and any facet type added
         later. filter_action separates "buyers want in-stock only" from
         "buyers gave up and cleared it", which is the whole point of the
         report. */
      document.addEventListener('change', function (e) {
        var el = e.target;
        if (!el || !el.name) return;

        if (el.name === 'sort_by') {
          ga('event', 'sort_apply', {
            sort_type: el.value,
            content_group: group()
          });
          return;
        }

        if (el.name.indexOf('filter.') !== 0) return;
        var name = el.name.replace(/^filter\./, '');
        var value = el.getAttribute('data-label') || el.value || '';
        var applied = el.type === 'checkbox' ? el.checked : !!el.value;
        ga('event', 'filter_apply', {
          filter_name: name.slice(0, 60),
          filter_value: String(value).slice(0, 60),
          filter_action: applied ? 'apply' : 'remove',
          content_group: group()
        });
      }, true);

      /* ---------- cart quantity ----------
         Driven by the /cart/change response rather than by the DOM, because the
         same control exists in the cart page and in the drawer with different
         markup, and the response is the only place both agree. The seed above
         supplies the "before" for the first change of the page. */
      (function () {
        var seedEl = document.getElementById('hl-cart-seed');
        var snapshot = { count: 0, value: 0, lines: {} };
        try { if (seedEl) snapshot = JSON.parse(seedEl.textContent); } catch (e) {}
        CART.count = snapshot.count || 0;
        CART.value = snapshot.value || 0;

        // silent = update the snapshot without reporting. Used after an
        // add_to_cart: the line is new, the pixel has already reported it, and
        // without this re-seed the FIRST quantity edit of that new line would
        // have no "before" and would be silently dropped.
        function reconcile(cart, silent) {
          if (!cart || !cart.items || !cart.items.length) return;
          var next = {};
          for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            next[String(it.variant_id || it.id)] = it.quantity;
            var before = snapshot.lines[String(it.variant_id || it.id)];
            // undefined = a line that did not exist, i.e. an add_to_cart, which
            // the app pixel already reports. Only report edits of a line that
            // was already there, and only upward or downward-but-not-to-zero:
            // zero is remove_from_cart, also already covered.
            if (!silent && before !== undefined && before !== it.quantity && it.quantity > 0) {
              ga('event', 'cart_quantity_change', {
                item_id: String(it.product_id || ''),
                product_handle: it.handle || undefined,
                qty_from: before,
                qty_to: it.quantity,
                cart_value: (cart.total_price || 0) / 100,
                item_count: cart.item_count,
                currency: cart.currency || undefined,
                content_group: group()
              });
            }
          }
          snapshot = {
            count: cart.item_count,
            value: (cart.total_price || 0) / 100,
            lines: next
          };
          CART.count = snapshot.count;
          CART.value = snapshot.value;
        }

        // Wrapping fetch is the light-touch option: the theme, the drawer and
        // any app all go through it, and a clone() of the response means the
        // theme still reads its own body normally.
        //
        // Three rules this wrapper must never break, because everything the
        // shop earns goes through it:
        //   1. non-cart requests are handed straight back, untouched;
        //   2. the response object the caller receives is the original one;
        //   3. nothing this file does can reject a promise the theme awaits —
        //      the clone is read on a side branch with its own catch.
        var nativeFetch = window.fetch;
        if (typeof nativeFetch !== 'function') return;
        var safeReconcile = function (cart, silent) {
          try { reconcile(cart, silent); } catch (e) {}
        };
        window.fetch = function (input) {
          var p = nativeFetch.apply(this, arguments);
          try {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            var isAdd = /\/cart\/add/.test(url);
            if (!isAdd && !/\/cart\/(change|update|clear)/.test(url)) return p;
            p.then(function (res) {
              try {
                /* An add that the cart REFUSED.
                   This store has shipped a state where every product read as
                   available and none could be bought: the inventory location
                   was missing from the shipping profile, so /cart/add answered
                   422 while the button looked perfectly normal. Nothing in the
                   funnel showed it — atc_click rose, add_to_cart did not, and
                   the difference between "changed their mind" and "the shop is
                   broken" was invisible.

                   Shopify puts a machine-readable reason in the body, so the
                   answer is read on a side branch — never the caller's copy —
                   and the event carries the status and the description. */
                if (isAdd && !res.ok) {
                  var status = res.status;
                  res.clone().json().then(function (err) {
                    ga('event', 'add_to_cart_failed', {
                      status: status,
                      reason: String((err && (err.description || err.message)) || 'unknown').slice(0, 120),
                      product_handle: handleOf(location.pathname) || undefined,
                      content_group: group()
                    });
                  }, function () {
                    ga('event', 'add_to_cart_failed', {
                      status: status, reason: 'unparseable', content_group: group()
                    });
                  });
                  return;
                }
                if (isAdd) {
                  // /cart/add.js answers with the line that was added, not with
                  // the cart, so there is nothing to diff against. Re-read the
                  // cart once — the only extra request this file ever makes,
                  // and only after a visitor has actually put something in it.
                  nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
                    .then(function (r) { return r.json(); })
                    .then(function (c) { safeReconcile(c, true); }, function () {});
                  return;
                }
                res.clone().json().then(safeReconcile, function () {});
              } catch (e) {}
            }, function () {});
          } catch (e) {}
          return p;
        };
      })();

      /* ---------- section_view + footer_view ----------
         Added 2026-08-14 after a mobile audit: scroll_depth said how FAR down
         the page someone got, and nothing said WHAT they got to. On a PDP that
         is 8,700px tall on a phone, "75%" could be the FAQ, the recommendation
         strip or the category rows, and the three mean completely different
         things about what to build next.

         Named after the Shopify section, so the label survives a re-order of
         the page and reads the same as the theme editor: main, hl_faq,
         product_recommendations, hl_more_category, hl_other_category, footer.

         The trigger is a rootMargin, not a threshold, and that is the whole
         trick. Any percentage threshold is a trap here because these sections
         have no common size: the FAQ is 1,600px on a phone and the blog index
         is a SINGLE section 26,703px tall. 15% of that is 4,005px of an 844px
         screen — unreachable, so the one section that holds the entire blog
         would silently never report. A -80px inset instead means "80px of it
         got into the viewport", which reads the same on a 200px block and on a
         26,000px one. */
      if ('IntersectionObserver' in window) {
        var sections = document.querySelectorAll('.shopify-section');
        var secObs = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            var s = entries[i].target;
            var id = (s.id || '')
              .replace(/^shopify-section-/, '')
              .replace(/^(sections|template)--\d+__/, '')
              .replace(/_[A-Za-z0-9]{6}$/, '');       // theme's random block suffix
            if (!once('section:' + id)) { secObs.unobserve(s); continue; }
            /* headingOf(), not the first h1/h2: on the collection template the
               first heading inside the main section belongs to the filter
               panel, so this section reported itself as "Filter 0". */
            var h = headingOf(s);
            ga('event', 'section_view', {
              section_id: id.slice(0, 60),
              section_name: h || id.slice(0, 60),
              section_index: i + 1,
              product_handle: handleOf(location.pathname) || undefined,
              content_group: group()
            });
            secObs.unobserve(s);
          }
        }, { threshold: 0, rootMargin: '-80px 0px -80px 0px' });
        Array.prototype.forEach.call(sections, function (s) {
          // The cart drawer is a section with zero height until it opens; an
          // always-collapsed element never intersects and would just sit in the
          // observer for the life of the page.
          if (s.getBoundingClientRect().height > 40) secObs.observe(s);
        });

        /* footer_view separately and by name, because "did anyone ever reach
           the footer" is the one question asked about it — and the footer holds
           the newsletter form, the policies and the contact address, each of
           which is a different reason to care. */
        var footEl = document.querySelector('footer');
        if (footEl) {
          var footObs = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting && once('footer_view')) {
                ga('event', 'footer_view', {
                  product_handle: handleOf(location.pathname) || undefined,
                  content_group: group()
                });
                footObs.disconnect();
              }
            }
          }, { threshold: 0, rootMargin: '-80px 0px -80px 0px' });
          footObs.observe(footEl);
        }
      }

      /* ---------- product_list_view: what was SHOWN, not just what was clicked ----------
         select_item has always recorded the click on a card. Nothing recorded
         the card being seen, so every merchandising question was unanswerable:
         a product with no clicks could be a bad product or a product nobody
         scrolled to, and those want opposite responses.

         One event per LIST, not per card. A collection page carries 38 cards;
         at ~90 visits a day, per-card impressions would be ~80k events a month
         spent on a number that per-list already answers. The positions ride
         along in a list of objects, which is the shape Mixpanel breaks down
         natively, so "click-through by position" still works.

         A list is any element with two or more cards directly under it. That
         definition, rather than a class name, is what makes this survive the
         three different card systems this storefront ships (theme grid,
         resource-list, hl-cat-row) without naming any of them. */
      if ('IntersectionObserver' in window) {
        var lists = [];
        var cards = cardsIn(document);
        for (var ci = 0; ci < cards.length; ci++) {
          var parent = listContainer(cards[ci]);
          if (parent && lists.indexOf(parent) === -1) lists.push(parent);
        }
        var listObs = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            var el = entries[i].target;
            listObs.unobserve(el);
            var name = listName(el);
            if (!once('list:' + name)) continue;
            var inList = cardsIn(el);
            var items = [];
            for (var j = 0; j < inList.length && j < 20; j++) {
              var link = inList[j].querySelector('a[href*="/products/"]');
              items.push({
                product_id: inList[j].getAttribute('data-product-id'),
                product_handle: handleOf(link && link.getAttribute('href')),
                position: j + 1
              });
            }
            ga('event', 'product_list_view', {
              item_list_name: name,
              item_count: inList.length,
              items: items,
              content_group: group()
            });
          }
        }, { threshold: 0, rootMargin: '-80px 0px -80px 0px' });
        for (var li = 0; li < lists.length; li++) listObs.observe(lists[li]);
      }

      /* One element per product, in document order.
         `[data-product-id]` is NOT one-per-card on this theme: the card wrapper
         carries it and so does the <quick-add-component> nested inside it.
         Measured on /collections/wall-shelves — a 29-product collection —
         a raw querySelectorAll returned 55 matches, every id twice. Three
         separate defects fell out of that one fact: an impression event
         claiming 55 products, a position counted against a doubled list, and a
         card click that resolved to the quick-add element, found no product
         link inside it, and silently reported nothing at all.
         Deduplicating by id, keeping the OUTERMOST match, fixes all three. */
      function cardsIn(el) {
        var out = [], seen = {};
        var all = el ? el.querySelectorAll('[data-product-id]') : [];
        for (var i = 0; i < all.length; i++) {
          var id = all[i].getAttribute('data-product-id');
          if (!id || seen[id]) continue;
          seen[id] = 1;
          out.push(all[i]);
        }
        return out;
      }

      /* The card element for a clicked target: the nearest ancestor carrying a
         product id that actually contains a product link, so a click inside
         <quick-add-component> resolves to the card around it rather than to
         the component, which knows the id but not the handle. */
      function cardOf(target) {
        var el = target && target.closest && target.closest('[data-product-id]');
        while (el) {
          if (el.querySelector('a[href*="/products/"]')) return el;
          el = el.parentElement && el.parentElement.closest('[data-product-id]');
        }
        return target && target.closest ? target.closest('[data-product-id]') : null;
      }

      /* The element that IS the grid: walk up from a card until an ancestor
         holds two or more DISTINCT products. Defined by shape rather than by
         class name, which is what lets one function serve the three unrelated
         card systems this storefront ships. */
      function listContainer(card) {
        var parent = card && card.parentElement;
        while (parent && parent !== document.body) {
          if (cardsIn(parent).length >= 2) return parent;
          parent = parent.parentElement;
        }
        return null;
      }

      /* The name a grid answers to, shared by product_list_view and
         select_item so the impression and the click join on one value. */
      /* The first heading in a section that is actually ABOUT the section.
         Measured on /collections/wall-shelves: the first h2 inside the main
         section belongs to the filter panel, so the collection's 55-product
         grid was named "Filter 0" — a label that is not wrong so much as
         meaningless, and it would have sat at the top of every merchandising
         report. */
      function headingOf(section) {
        var heads = section
          ? section.querySelectorAll('h1, h2, .section-header__heading, .hl-cat-row__title')
          : [];
        for (var i = 0; i < heads.length; i++) {
          if (heads[i].closest('.facets, facet-filters, [class*="filter"], [class*="facet"]')) continue;
          var t = (heads[i].textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60);
          if (t && !/^filter/i.test(t)) return t;
        }
        return null;
      }

      /* 'grid' was 40% of every product_list_view in September, and 160 of its
         171 were the product cards inside blog articles, which have no heading
         of their own. They are named for where they are. */
      function listName(el) {
        var section = el.closest && el.closest('section, .shopify-section');
        return headingOf(section) ||
               (/\/collections\/([^/?#]+)/.exec(location.pathname) || [])[1] ||
               (/^\/blogs\//.test(location.pathname) ? 'blog_inline' : null) ||
               (/^\/search/.test(location.pathname) ? 'search_results' : null) ||
               'grid';
      }

      /* ---------- drawer_open ----------
         Every overlay on this theme is a <dialog>: the cart drawer, the search
         modal, the quick-add modal, the menu. One observer on the `open`
         attribute covers all of them and any added later, which a list of
         class names would not. The cart drawer matters most — on mobile it is
         the whole cart experience, and until now opening it was invisible. */
      (function () {
        var dialogs = document.querySelectorAll('dialog');
        if (!dialogs.length || typeof MutationObserver !== 'function') return;
        /* The cart drawer is identified by what it IS, not by its class, 2026-09-26.
           Its dialog is `theme-drawer__dialog color-custom-drawer`: no "cart" in
           it, and `color-custom-drawer` matched /color/, so for all of September
           the cart was reported as 'colour' and drawer_name:'cart' never fired
           once, which also meant cart_value / item_count were never attached.
           The blog's product modal was the anonymous 'other'; it gets a name. */
        function nameOf(d) {
          if (d.getAttribute('aria-labelledby') === 'cart-drawer-heading' ||
              d.querySelector('#cart-drawer-heading') ||
              (d.closest && d.closest('cart-drawer-component, cart-drawer'))) return 'cart';
          var c = (d.className || '').toString();
          return /hl-pdpm/.test(c) ? 'pdp_modal'
               : /cart/.test(c) ? 'cart'
               : /search/.test(c) ? 'search'
               : /quick-add/.test(c) ? 'quick_add'
               : /menu|nav/.test(c) ? 'menu'
               : /chat/.test(c) ? 'chat' : 'other';
        }
        var dObs = new MutationObserver(function (records) {
          for (var i = 0; i < records.length; i++) {
            var d = records[i].target;
            if (!d.hasAttribute('open')) continue;
            var n = nameOf(d);
            // Once per drawer per page: a shopper who opens the cart four
            // times is interesting, but not four times as interesting, and the
            // repeat is visible in the replay.
            if (!once('drawer:' + n)) continue;
            var props = { drawer_name: n, content_group: group() };
            if (n !== 'cart') { ga('event', 'drawer_open', props); continue; }
            cartDrawerSeen = true;
            /* The drawer opens while the add is still in flight, so CART still
               describes the cart before it (0 / 0 on a first add). Ask the cart
               itself; fall back to CART if that fails. The add takes ~1s to land, so the
               cart is read 1.4s after the drawer opens. */
            (function (props) {
              var sent = false;
              function fire(value, count) {
                if (sent) return;
                sent = true;
                props.cart_value = value;
                props.item_count = count;
                ga('event', 'drawer_open', props);
              }
              setTimeout(function () { fire(CART.value, CART.count); }, 3000);
              setTimeout(function () {
                fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
                  .then(function (r) { return r.json(); })
                  .then(function (c) { fire(c.total_price / 100, c.item_count); })
                  .catch(function () { fire(CART.value, CART.count); });
              }, 1400);
            })(props);
          }
        });
        for (var i = 0; i < dialogs.length; i++) {
          dObs.observe(dialogs[i], { attributes: true, attributeFilter: ['open'] });
        }
      })();

      /* ---------- blog_dwell ----------
         layout/theme.liquid already fires blog_read_time, but that is a
         THRESHOLD, not a duration: it fires once at 45 seconds and reports
         `seconds: 45` as a constant. Every one of the eleven that landed
         between 16 and 20 Aug 2026 said 45, which looks like a broken metric
         and is in fact a correctly-implemented flag with a misleading name --
         it answers "did they stay 45 seconds", and cannot answer "how long".

         That distinction matters here more than it would elsewhere: the blog is
         where AI assistants put their citations, and the post that took the two
         orders of that week -- "Scratches on a Steel Cutting Board" -- needs to
         be separable from a post someone bounced off at 46 seconds.

         So: real visible time, sampled on the way out, on article pages only.
         Different event name deliberately, so nothing that already reads
         blog_read_time changes meaning underneath it. */
      if (DATA.template === 'article') (function () {
        var visible = 0, last = Date.now(), sent = false;
        function settle() {
          var now = Date.now();
          if (document.visibilityState === 'visible') visible += now - last;
          last = now;
        }
        function flush() {
          settle();
          if (sent) return;
          sent = true;
          var secs = Math.round(visible / 1000);
          // Under two seconds is a prerender or a bounce off the back button,
          // not a read, and it would drag every average down.
          if (secs < 2) return;
          ga('event', 'blog_dwell', {
            article_handle: DATA.article_handle,
            blog_handle: DATA.blog_handle,
            seconds: secs,
            content_group: group()
          });
        }
        addEventListener('pagehide', flush);
        addEventListener('visibilitychange', function () {
          // settle() first either way: coming back from a background tab must
          // not bank the time the tab spent hidden.
          if (document.visibilityState === 'hidden') flush(); else settle();
        });
      })();

      /* ---------- cart_abandon ----------
         The gap this closes. begin_checkout is the Shopify pixel's, and it only
         exists once checkout has loaded; checkout_click is ours and only exists
         if the button was pressed. Between "the cart drawer is open" and either
         of those there was nothing at all, so a shopper who opened the drawer
         and stopped produced a drawer_open and then silence -- which reads in a
         report as a tracking hole rather than as the decision it actually is.

         Measured 16-20 Aug 2026: three shoppers opened the drawer, one pressed
         checkout. The other two are the whole question and neither left a
         record of where they got to.

         Fired on the way out, once, and only when the cart is non-empty and no
         checkout click has happened. `pagehide` rather than `beforeunload`
         because iOS never fires the latter, and the visibility fallback catches
         a tab that is backgrounded and killed rather than closed. */
      (function () {
        var sent = false;
        function abandon(how) {
          if (sent || !CART.count || fired['checkout_click']) return;
          sent = true;
          ga('event', 'cart_abandon', {
            cart_value: CART.value,
            item_count: CART.count,
            drawer_opened: !!cartDrawerSeen,
            exit_via: how,
            content_group: group()
          });
        }
        addEventListener('pagehide', function () { abandon('pagehide'); });
        addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'hidden') abandon('hidden');
        });
      })();

      /* ---------- checkout_click ----------
         The cart's own button. begin_checkout comes from the Shopify pixel and
         only fires once checkout has actually loaded, so a click that never
         becomes a checkout — the shipping-profile failure this shop has hit
         before — leaves no trace at all without this. */
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest(
          '[name="checkout"], a[href^="/checkout"], .cart__checkout-button, [href*="/checkouts/"]'
        );
        if (!b || !once('checkout_click')) return;
        ga('event', 'checkout_click', {
          checkout_from: location.pathname.indexOf('/cart') === 0 ? 'cart_page' : 'drawer',
          content_group: group()
        });
      }, true);

      /* ---------- atc_click and buy_now_click ----------
         Which control was pressed, not whether a cart happened — the cart is
         the Shopify pixel's job. Capture phase so it is recorded even when the
         theme's own handler stops propagation or re-renders the button.

         Site-wide now, and it was product-page-only, which was wrong in two
         ways. A collection page carries 38 quick-add buttons and none of them
         were counted. Worse, on a product page the recommendation strip has
         quick-add buttons too, and the old listener stamped every one of them
         with the PAGE's handle — a click on a recommended shelf was recorded
         as a click on the shelf being viewed.

         So the product is resolved from the CARD that was clicked when there
         is one, and only falls back to the page's own product otherwise.

         buy_now_click is separated out because it is a different decision:
         Shop Pay / PayPal / Apple Pay skip the cart entirely, so a shopper who
         presses it never appears in add_to_cart and never appears in the cart
         drawer. Without this event that path is invisible right up until the
         purchase lands. */
      document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest(
          '.shopify-payment-button__button, .sticky-add-to-cart__buynow, ' +
          '.sticky-add-to-cart__button, .add-to-cart-button, [name="add"]'
        );
        if (!t) return;

        var card = cardOf(t);
        var link = card && card.querySelector('a[href*="/products/"]');
        var cardHandle = handleOf(link && link.getAttribute('href'));
        var pageHandle = handleOf(location.pathname);

        var isBuyNow = t.classList.contains('shopify-payment-button__button') ||
                       t.classList.contains('sticky-add-to-cart__buynow');
        /* On a product page the main form sits inside a [data-product-id]
           element that also holds a /products/ link, so cardOf() took the page's
           own Add to cart for a product card: every atc_click in September said
           'product_card' and the main button never appeared. A "card" for the
           page's own product is the page. The blog's product modal gets its own
           name, so the modal's Add to cart can be told apart. */
        /* cardOf() falls back to the nearest [data-product-id] even when it holds
           no product link, and on the PDP that is the main product-form-component.
           Only an element that links to a product other than this page's is a card. */
        var isCard = !!(card && cardHandle && cardHandle !== pageHandle);
        var where = isBuyNow ? 'buy_now'
                  : t.closest('.hl-buybar') ? 'sticky_bar'
                  : t.closest('.hl-pdpm') ? 'pdp_modal'
                  : t.closest('dialog.quick-add-modal') ? 'quick_add_modal'
                  : t.closest('.sticky-add-to-cart__bar, .sticky-add-to-cart') ? 'sticky'
                  : isCard ? 'product_card'
                  : 'main';

        ga('event', isBuyNow ? 'buy_now_click' : 'atc_click', {
          atc_location: where,
          product_handle: cardHandle || pageHandle || undefined,
          item_list_name: isCard ? listName(card.parentElement || card) : undefined,
          content_group: group()
        });
      }, true);

      /* ---------- share_click ---------- */
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('.hl-share__link, [class*="share"] a[href]');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        var net = /pinterest/.test(href) ? 'pinterest'
                : /facebook/.test(href) ? 'facebook'
                : /twitter|x\.com/.test(href) ? 'x'
                : /mailto/.test(href) ? 'email'
                : /wa\.me|whatsapp/.test(href) ? 'whatsapp' : 'other';
        ga('event', 'share_click', {
          share_network: net,
          product_handle: handleOf(location.pathname) || undefined,
          content_group: group()
        });
      }, true);

      /* ---------- form_submit ----------
         Named from the form's action, not its class, so a newsletter box and a
         contact form are told apart without knowing either template. The field
         VALUES are never read. */
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || f.tagName !== 'FORM') return;
        var action = f.getAttribute('action') || '';
        var kind = /contact/.test(action) && f.querySelector('textarea') ? 'contact'
                 : /contact|customer/.test(action) ? 'newsletter'
                 : /search/.test(action) ? 'search'
                 : /cart/.test(action) ? 'cart' : 'other';
        // search and cart have their own events; newsletter has
        // email_capture_success, which additionally checks the address is
        // valid. Counting it twice under two names would make list growth look
        // like two different numbers depending on which chart you opened.
        if (kind === 'search' || kind === 'cart' || kind === 'newsletter') return;
        ga('event', 'form_submit', { form_type: kind, content_group: group() });
      }, true);

      /* ---------- paid_click_landed ----------
         Meta reports clicks; this reports arrivals. The gap between the two is
         the money spent on taps that never became a session — accidental
         thumbs, bots, and pages too slow to survive the Instagram in-app
         browser. Nothing else in this file can see it, because every other
         event presumes the visit already happened.

         Once per session, keyed the same 30 minutes the channel label uses. */
      (function () {
        var q;
        try { q = new URLSearchParams(location.search); } catch (e) { return; }
        var id = q.get('fbclid') || q.get('gclid') || q.get('gbraid') ||
                 q.get('wbraid') || q.get('ttclid') || q.get('msclkid');
        if (!id) return;
        try {
          var last = parseInt(sessionStorage.getItem('hl_paid_seen') || '0', 10) || 0;
          if (Date.now() - last < 30 * 60 * 1000) return;
          sessionStorage.setItem('hl_paid_seen', String(Date.now()));
        } catch (e) { /* private mode: report it, a duplicate beats a blind spot */ }
        ga('event', 'paid_click_landed', {
          click_id_type: q.get('fbclid') ? 'fbclid'
                       : q.get('ttclid') ? 'ttclid'
                       : q.get('msclkid') ? 'msclkid' : 'google',
          landing_path: location.pathname,
          utm_campaign: q.get('utm_campaign') || '(none)',
          utm_content: q.get('utm_content') || '(none)',
          content_group: group()
        });
      })();

      /* ---------- no_results ----------
         A search or a filter that returns nothing is a guaranteed lost visit,
         and at this volume each one is readable individually rather than as a
         rate — which is exactly what makes it worth an event. The count comes
         from the rendered grid rather than from Liquid so it is also correct
         after a filter re-render, which Liquid never sees. */
      (function () {
        var isSearch = /^\/search/.test(location.pathname);
        var isCollection = /^\/collections/.test(location.pathname);
        if (!isSearch && !isCollection) return;
        /* Search takes its answer from Liquid, not from the DOM. Measured
           2026-08-16: /search?q=zzzqqqnothing renders the full 29-product
           catalogue as suggestions, so counting cards would report "results"
           for a query that found nothing — the one case this event exists for.
           Collections have no such fallback, so there the DOM is the truth,
           and it is also the only thing that stays correct after a filter
           re-renders the grid without a page load. */
        var searchEmpty = DATA.template === 'search' ? DATA.search_results_count === 0 : false;
        setTimeout(function () {
          if (isSearch ? !searchEmpty : cardsIn(document).length) return;
          if (!once('no_results')) return;
          var q;
          try { q = new URLSearchParams(location.search); } catch (e) { q = null; }
          ga('event', 'no_results', {
            no_results_context: isSearch ? 'search' : 'collection',
            search_term: (q && q.get('q')) || '(none)',
            filters_active: (q ? q.toString().split('&').filter(function (p) {
              return p.indexOf('filter.') === 0;
            }).length : 0),
            requested_path: location.pathname + location.search,
            content_group: group()
          });
        }, 1200);
      })();

      /* ---------- policy_page_view ----------
         Shipping, returns, refunds, privacy, terms. `had_cart` is the whole
         point: a visitor with a loaded cart reading the returns policy is the
         purest objection signal a shop gets, and if they do not come back, the
         policy — or the way it is written — cost the order. */
      (function () {
        var p = location.pathname;
        var kind = /polic/.test(p) && /shipping|delivery/.test(p) ? 'shipping'
                 : /refund|return/.test(p) ? 'returns'
                 : /privacy/.test(p) ? 'privacy'
                 : /terms|tos/.test(p) ? 'terms'
                 : /shipping|delivery/.test(p) ? 'shipping'
                 : /^\/policies\//.test(p) ? 'other_policy' : null;
        if (!kind) return;
        var cart = { count: 0, value: 0 };
        try { cart = JSON.parse(document.getElementById('hl-cart-seed').textContent); } catch (e) {}
        ga('event', 'policy_page_view', {
          policy_type: kind,
          had_cart: (cart.count || 0) > 0,
          cart_value: cart.value || 0,
          content_group: group()
        });
      })();

      /* ---------- image_load_failed ----------
         On a shop whose product IS the photograph, a broken image is a broken
         shop, and it is invisible in every other report: the page still loads,
         the events still fire, the visitor just leaves. Capture phase because
         `error` on <img> does not bubble. */
      document.addEventListener('error', function (e) {
        var el = e.target;
        if (!el || el.tagName !== 'IMG') return;
        var src = el.currentSrc || el.src || '';

        /* Was once('imgfail') — one key for the whole page, so a page with six
           broken images reported one and the other five were invisible. Keyed
           on the file now, which still stops a retrying <img> from spamming the
           same event while letting a genuinely broken page report as broken. */
        var u, host = '(unknown)', path = '(unknown)';
        try {
          u = new URL(src, location.href);
          host = u.hostname;
          /* Filename plus one parent, not the whole URL: Shopify CDN paths are
             ~150 characters of hash and query and the tail is the only part
             that identifies the file. Without this the previous 12 events named
             a host and nothing else, which is not enough to go and fix one. */
          path = u.pathname.split('/').slice(-2).join('/').slice(0, 90);
        } catch (x) {}
        if (!once('imgfail:' + path)) return;

        ga('event', 'image_load_failed', {
          image_host: host,
          image_path: path,
          is_product_image: !!el.closest('[data-product-id], product-component, .product-media'),
          content_group: group()
        });
      }, true);

      if (DATA.template === '404') {
        /* A 404 is a broken link, a dead ad destination or a URL that used to
           be a product. page_type already says '404'; this carries the path
           that was asked for and where it was asked from, which is what makes
           it fixable rather than merely countable. */
        ga('event', 'page_not_found', {
          requested_path: location.pathname + location.search,
          referrer: document.referrer || '(direct)',
          content_group: 'other'
        });
      }

      /* ---------- product page only ---------- */
      var handle = handleOf(location.pathname);
      if (!handle) return;
      var pid = productId();

      /* ---------- pdp_read_depth ----------
         The product copy — description, specs, care, the category rows — all
         lives in one column that is ~4,800px tall on a phone. scroll_depth
         measures the whole document, which on this template is dominated by
         what comes AFTER that column, so a reader who finished the description
         and left looked identical to one who scrolled past everything.

         Same technique as blog_read_depth in layout/theme.liquid: watch the
         column's own child blocks and map each threshold to the block sitting
         at that share of them. Percentages of the copy, not of the page. */
      (function () {
        var col = document.querySelector('[data-testid="product-information-details"]') ||
                  document.querySelector('.product-details');
        if (!col) return;

        /* Measured from the column's own GEOMETRY, not from its child elements.
           The first attempt mapped the four thresholds onto the column's direct
           children and reported nothing useful: the details column has 9
           children on this theme, eight of them under 140px (variant picker,
           price, buy buttons, share row) and the ninth 3,999px tall holding all
           the actual copy. Counting children put 25/50/75% inside the first
           500px and 100% at the START of the description.

           Reading the rectangle instead makes a percentage mean a percentage,
           and survives the theme re-nesting its wrappers — which it does often. */
        var marks = [25, 50, 75, 100];
        var readFired = 0, readQueued = false;

        function check() {
          readQueued = false;
          var r = col.getBoundingClientRect();
          if (r.height < 600) return;        // too short for a depth to mean anything
          var passed = Math.min(r.height, Math.max(0, window.innerHeight - r.top));
          var pct = Math.round((passed / r.height) * 100);
          for (var i = 0; i < marks.length; i++) {
            if (pct >= marks[i] && once('pdpread:' + marks[i])) {
              readFired++;
              ga('event', 'pdp_read_depth', {
                percent_scrolled: marks[i],
                product_handle: handle,
                content_group: 'product'
              });
            }
          }
          if (readFired >= marks.length) document.removeEventListener('scroll', onReadScroll, true);
        }

        /* Same three changes as scroll_depth above, and the gallery guard
           matters more here: this measures the DESCRIPTION COLUMN against the
           viewport, and a horizontal flick of the photographs cannot move
           either one. It was taking a getBoundingClientRect and an innerHeight
           on every scroll event of that flick. */
        function onReadScroll(e) {
          var el = e.target === document ? document.documentElement : e.target;
          if (!canOwnDepth(el)) return;
          if (readQueued) return;
          readQueued = true;
          requestAnimationFrame(check);
        }
        // Capture phase for the same reason as scroll_depth: on this theme the
        // scrolling element is sometimes an inner container, not the window.
        document.addEventListener('scroll', onReadScroll, { capture: true, passive: true });
        check();                             // a short column can already be read on load
      })();

      /* variant_select — option churn before the decision.
         previous_variant is what makes this readable: "Large → Medium" says the
         first choice was wrong, while a bare "Medium" says nothing. */
      var lastVariant = '';
      document.addEventListener('change', function (e) {
        var picker = e.target.closest && e.target.closest('variant-picker, .variant-picker, .variant-option');
        if (!picker) return;
        var label = e.target.closest('label');
        var value = ((label && label.textContent) || e.target.value || '').replace(/\s+/g, ' ').trim();
        var previous = lastVariant;
        lastVariant = value;
        // Getting the price right here took two attempts on the live PDP, both
        // worth spelling out:
        //
        //   the block   the first .price in DOM order belongs to the cart
        //               drawer / recommendation strip and reported $221.84 for
        //               a $54.99 board. Pin to <product-price data-product-id>.
        //   the timing  the theme re-renders the price AFTER this change event,
        //               so any fixed delay is a guess — 350ms still reported
        //               $49.99 while the page showed $54.99. Wait for the value
        //               to actually change instead of guessing how long that
        //               takes.
        //
        // Variants that genuinely share a price never change the text, so the
        // poll gives up after 1.5s and reports the price that is on screen —
        // which is the correct answer in that case anyway.
        function priceNow() {
          var block = document.querySelector('product-price[data-product-id]');
          var el = block && (block.querySelector('.price-item--sale.price') || block.querySelector('.price'));
          return el ? el.textContent.trim() : '';
        }
        var was = priceNow();
        var deadline = Date.now() + 1500;
        (function settle() {
          var now = priceNow();
          if (now === was && Date.now() < deadline) { setTimeout(settle, 100); return; }
          ga('event', 'variant_select', {
            variant_option: value.slice(0, 60),
            previous_variant: previous ? previous.slice(0, 60) : '(none)',
            value: money(now) || undefined,
            currency: DATA.currency,
            product_handle: handle,
            content_group: 'product'
          });

          /* variant_unavailable_select — the combination the shopper asked for
             and could not have.

             Every other event here measures interest in something you sell.
             This one measures interest in something you do not, which for a
             29-product catalogue is a merchandising instruction rather than a
             statistic: ten of these in a month name the variant to stock next.
             It is read off the buy button, after the same settle poll the price
             uses, because the theme re-renders the button asynchronously and a
             fixed delay reads the previous variant's state. */
          var btn = document.querySelector('.add-to-cart-button, [name="add"]');
          var soldOut = btn && (btn.disabled ||
            /sold\s*out|out of stock|unavailable/i.test(btn.textContent || ''));
          if (soldOut) {
            ga('event', 'variant_unavailable_select', {
              variant_option: value.slice(0, 60),
              previous_variant: previous ? previous.slice(0, 60) : '(none)',
              product_handle: handle,
              content_group: 'product'
            });
          }
        })();
      }, true);

      /* quantity_change — the PDP stepper.
         Debounced by 700ms so four clicks from 1 to 5 report one 1 → 5 and not
         four adjacent events; the interesting fact is the number the shopper
         settled on, not the path they took to it. */
      (function () {
        var qtyInput = document.querySelector('quantity-selector-component input[name="quantity"]');
        if (!qtyInput) return;
        var from = parseInt(qtyInput.value, 10) || 1;
        var timer = null;
        function settle() {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var to = parseInt(qtyInput.value, 10) || 1;
            if (to === from) return;
            ga('event', 'quantity_change', {
              item_id: pid || undefined,
              product_handle: handle,
              qty_from: from,
              qty_to: to,
              content_group: 'product'
            });
            from = to;
          }, 700);
        }
        var comp = qtyInput.closest('quantity-selector-component');
        comp.addEventListener('click', function (e) {
          if (e.target.closest('button')) settle();
        }, true);
        qtyInput.addEventListener('change', settle);
      })();

      /* ---------- gallery ----------
         product_image_view is an IntersectionObserver on the slides rather than
         a click handler, because the three ways to reach image 4 (swipe, arrow,
         thumbnail) produce different clicks and identical intent. image_source
         records which one, set by whichever control was last pressed.

         Scoped inside media-gallery on purpose: the announcement bar is also a
         slideshow-component, and a site-wide observer would report the banner
         rotating as product interest. */
      (function () {
        var gallery = document.querySelector('media-gallery');
        if (!gallery || !('IntersectionObserver' in window)) return;
        var slides = gallery.querySelectorAll('slideshow-slide, .product-media-container');
        if (!slides.length) return;

        var source = 'load';
        gallery.addEventListener('click', function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          if (t.closest('.slideshow-controls__thumbnail')) source = 'thumbnail';
          else if (t.closest('.slideshow-control--next, .slideshow-control--previous')) source = 'arrow';
        }, true);
        // A scroll inside the slides container is a swipe; anything else that
        // moved the strip already set source above.
        var scroller = gallery.querySelector('slideshow-slides, [ref="scroller"]');
        if (scroller) {
          scroller.addEventListener('scroll', function () {
            if (source === 'load') source = 'swipe';
          }, { passive: true });
        }

        var obs = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            var idx = Array.prototype.indexOf.call(slides, entries[i].target) + 1;
            if (!once('img:' + idx)) continue;
            ga('event', 'product_image_view', {
              item_id: pid || undefined,
              product_handle: handle,
              image_index: idx,
              image_source: idx === 1 ? 'load' : source,
              content_group: 'product'
            });
            // Reset so the next slide is attributed to its own control rather
            // than inheriting the previous one.
            source = 'swipe';
          }
        }, { root: scroller || null, threshold: 0.6 });
        Array.prototype.forEach.call(slides, function (s) { obs.observe(s); });

        /* product_image_zoom used to be reported from here by polling for the
           dialog after a tap. It is image_zoom_open now, sent by the dialog
           itself — see the hl:zoom listener near scroll_depth. */
      })();

      /* ---------- price ----------
         price_interaction: a click on the price, or a deliberate 1.2s dwell on
         it. The dwell is what makes this worth having — nobody clicks a price,
         they stare at it, and "stared at the price then left" is a different
         diagnosis from "never scrolled to it".

         discount_view: fires on load when the theme rendered a compare-at
         price, with the percentage already computed so no report has to derive
         it from two metrics. */
      (function () {
        // [data-product-id] pins this to the product's own price block. Without
        // it the selector can match the cart drawer or a recommendation card —
        // see the variant_select note above for what that costs.
        var priceBlock = document.querySelector('product-price[data-product-id]');
        if (!priceBlock) return;
        var saleEl = priceBlock.querySelector('.price-item--sale.price, .price');
        var cmpEl = priceBlock.querySelector('.compare-at-price, .price-item--regular.compare-at-price');
        var price = money(saleEl && saleEl.textContent);
        var compare = money(cmpEl && cmpEl.textContent);
        var currency = DATA.currency;

        function interaction() {
          if (!once('price_interaction')) return;
          ga('event', 'price_interaction', {
            value: price || undefined,
            compare_price: compare || undefined,
            currency: currency,
            product_handle: handle,
            content_group: 'product'
          });
        }
        priceBlock.addEventListener('click', interaction);
        var dwell = null;
        priceBlock.addEventListener('pointerenter', function () {
          dwell = setTimeout(interaction, 1200);
        });
        priceBlock.addEventListener('pointerleave', function () { clearTimeout(dwell); });

        if (compare && price && compare > price && once('discount_view')) {
          ga('event', 'discount_view', {
            value: Math.round((compare - price) * 100) / 100,
            compare_price: compare,
            discount_percent: Math.round(((compare - price) / compare) * 100),
            currency: currency,
            product_handle: handle,
            content_group: 'product'
          });
        }
      })();

      /* faq_open — reuses link_text, already registered for the blog.
         The <summary> toggles on click, so the open state is read on the next
         tick: without that this counted closing a question as opening it and
         every FAQ looked twice as load-bearing as it is. faq_id is the position
         in the list, which survives the wording of a question changing. */
      document.addEventListener('click', function (e) {
        var q = e.target.closest && e.target.closest('.hl-faqx-q, .hl-faqx-btn');
        if (!q) return;
        var item = q.closest('details, .hl-faqx-item');
        var list = document.querySelectorAll('.hl-faqx-item');
        var idx = Array.prototype.indexOf.call(list, item) + 1;
        setTimeout(function () {
          if (item && item.tagName === 'DETAILS' && !item.open) return;   // was a close
          ga('event', 'faq_open', {
            link_text: text(q, 100),
            faq_id: idx > 0 ? String(idx) : 'cta',
            product_handle: handle,
            content_group: 'product'
          });
        }, 0);
      }, true);

      /* out_of_stock_view — fires once, after the variant picker has settled.
         Checked on a delay because the button is re-rendered client-side when a
         variant is preselected from the URL, and the first paint can show an
         enabled button that turns into "Sold out" a moment later. */
      setTimeout(function () {
        var btn = document.querySelector('.add-to-cart-button, [name="add"]');
        if (!btn) return;
        var soldOut = btn.disabled || /sold\s*out|out of stock|unavailable/i.test(btn.textContent || '');
        if (soldOut) {
          ga('event', 'out_of_stock_view', {
            product_handle: handle,
            content_group: 'product'
          });
        }
      }, 1500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
